<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="about-me">关于我</div>
      <div class="hint">选择符合你的描述吧</div> -->
      <img class="pic-about-me" src="https://static.huiyiji520.com/cppic-1661154078.png">
      <img class="pic-hint" src="https://static.huiyiji520.com/cppic-1661174438.png">
      <div class="hint second">（至多选6个）</div>

      <div class="words flex-box">
        <div class="word" v-for="(word, index) in words" :key="index" @click="pickTag(word)"
        :style="{color: getBtnColor(word), backgroundColor: getBtnBackground(word)}">
          {{ word }}
        </div>
      </div>

      <div class="arrows">
        <div class="signs flex-box">
          <!-- <div class="prev" @click="goBack()"><van-icon name="arrow-left" color="#eb8e80" />上一步</div>
          <div class="next" @click="goNext()">下一步<van-icon name="arrow" color="#eb8e80" /></div> -->
          <img class="pic-prev" @click="goBack()" src="https://static.huiyiji520.com/cppic-1661159773.png">
          <img class="pic-next" @click="goNext()" src="https://static.huiyiji520.com/cppic-1661157292.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Icon } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon
  },
  data(){
    return {
      words: [
        // "吃货", "摄影", "旅行", "二次元", "设计师", "产品狗",
        // "自媒体", "读书", "追剧狂", "运动", "音乐", "程序员"
        "吃货", "游戏达人", "摄影",
        "二次元", "社交牛人", "行动派",
        "电影", "文艺青年", "读书",
        "音乐", "运动健身", "做题家",
        "旅行", "佛系青年", "乐天派"
      ],
      tags: []
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goBack(){
      this.$router.back()
    },
    goNext(){
      if(this.tags.length == 0){
        Toast('选择符合你的标签～')
      }else{
        let cpchoose = this.$store.state.cpchoose
        cpchoose.myTags = this.tags
        this.$store.commit('updateCpChoose', cpchoose)
        this.handleRouter('/choose_me_contact')
      }
    },
    pickTag(word){
      if(this.tags.length >= 6 &&  !this.tags.includes(word)){
        Toast('至多选6个标签哦～')
      }else{
        this.tags.includes(word) ? this.tags.splice(this.tags.findIndex(item => item == word), 1) : this.tags.push(word)
      }
    },
    getBtnColor(word){
      return this.tags.includes(word) ? '#fff' : '#f1b8af'
    },
    getBtnBackground(word){
      return this.tags.includes(word) ? '#f1b8af' : '#fff'
    },
    recoverTags(){
      this.tags = this.$store.state.cpchoose.myTags ? this.$store.state.cpchoose.myTags : this.tags
    }
  },
  mounted(){
    this.recoverTags()
    this.$report.submit('/choose_me_tags', this.$store.state.issue, this.$store.state.userinfo.openid)
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661155471.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .about-me{margin-top:200px;margin-bottom:134px;font-size:70px;color:#eb8e80;}
.main .hint{font-size:40px;line-height:40px;color:#eb8e80;margin-bottom:32px;}
.main .pic-about-me{width:206px;height:68px;margin:0 auto;margin-top:208px;margin-bottom:134px;}
.main .pic-hint{width:374px;height:40px;margin:0 auto;margin-bottom:32px;}
.main .hint.second{font-size:32px;margin-bottom:77px;}
.main .words{justify-content:space-between;flex-wrap: wrap;padding:0px 80px;}
.main .words .word{
  font-size:32px;width:180px;border:3px solid #f1b8af;border-radius:40px;
  margin-bottom:50px;padding:5px 0px;color:#eb8e80;background:#fff;
}
.main .arrows{position: fixed;bottom:120px;width:100%;}
.main .arrows .signs{
  justify-content:space-between;padding:0px 194px;
  font-size:32px;color:#eb8e80;
}
.main .pic-prev{width:120px;height:32px;}
.main .pic-next{width:120px;height:32px;}
</style>
